import { t } from './i18n';
import { shareUrl } from './seo';

export async function shareLink(params: Record<string, string>, title?: string): Promise<void> {
  const url = shareUrl(params);
  if (navigator.share) {
    try {
      await navigator.share({ title: title ?? 'moser.ink', url });
      return;
    } catch (err) {
      if ((err as DOMException).name === 'AbortError') return;
    }
  }
  await navigator.clipboard.writeText(url);
  // Brief toast via title attribute on a transient element — keep minimal
  const toast = document.createElement('div');
  toast.className = 'share-toast';
  toast.textContent = t('shareCopied');
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('visible'));
  setTimeout(() => toast.remove(), 2200);
}
